import HeroSection from "./HeroSection";
import WhyWe from "../WhyWe";
import ImageCarousel from "../ImageCarousel";
import TrustedByCustomers from "./TrustedByCustomers";
import ExperienceCategories from "./ExperienceCategories";
function HomePage() {
  return (
    <div>
      <HeroSection />
      <ExperienceCategories />
      <WhyWe />
      <TrustedByCustomers />
      <ImageCarousel />
    </div>
  );
}

export default HomePage;
